import _find from 'lodash/find'
// import { ProductForm } from '@shopify/theme-product-form'

class ProductFormElement extends HTMLElement {
  constructor () {
    super()

    const FOOTER_SELECTOR = '.js-site-footer'
    const VARIANT_TITLE_SELECTOR = '.js-variant-title'
    const ADD_TO_CART_SELECTOR = '.js-pdp-add-to-cart'
    const fixedClass = 'is-fixed'
    const variantTitle = this.querySelectorAll(VARIANT_TITLE_SELECTOR)
    const addToCart = document.querySelector(ADD_TO_CART_SELECTOR)
    const footerEl = document.querySelector(FOOTER_SELECTOR)

    if (this.dataset.variants) {
      this.variants = JSON.parse(this.dataset.variants)
    }

    const formEl = this.querySelector('form')
    if (formEl) {
      const optionOnLoad = formEl.querySelector('[data-option="1"] input[type="radio"]:checked')
      if (variantTitle && optionOnLoad) variantTitle[0].innerHTML = optionOnLoad.value

      formEl.addEventListener('change', (event) => {
        if (event.target.closest('[data-option]')) {
          this.onOptionChange(event, variantTitle)
        }
      })

      formEl.addEventListener('submit', (event) => {
        event.preventDefault()
        document.querySelector('shopify-cart').addItemFromForm(event.target)
      })
    }

    const isInViewport = (elem) => {
      const distance = elem.getBoundingClientRect()
      return (
        distance.bottom <= 0
      )
    }

    const stoppingPoint = footerEl ? footerEl.offsetTop : null

    if (addToCart) {
      window.addEventListener('scroll', function (event) {
        const scrollTop = window.scrollY
        if (isInViewport(addToCart, scrollTop) && (stoppingPoint ? (scrollTop < stoppingPoint) : true)) {
          addToCart.parentNode.classList.add(fixedClass)
        } else {
          addToCart.parentNode.classList.remove(fixedClass)
        }
      }, { passive: true })
    }
  }

  onOptionChange (event, variantTitle) {
    const formEl = this.querySelector('form')

    const option1 = formEl.querySelector('[data-option="1"] input[type="radio"]:checked')
    const option2 = formEl.querySelector('[data-option="2"] input[type="radio"]:checked')
    const option3 = formEl.querySelector('[data-option="3"] input[type="radio"]:checked')

    const matchingVariant = _find(this.variants, {
      option1: option1?.value || null,
      option2: option2?.value || null,
      option3: option3?.value || null
    })

    this.querySelector('input[name="id"]').value = matchingVariant.id

    if (variantTitle) variantTitle[0].innerHTML = matchingVariant.title

    this.dispatchEvent(new CustomEvent('change-variant', {
      detail: { id: matchingVariant.id },
      bubbles: true
    }))
  }
}

customElements.define('product-form', ProductFormElement)
